import {BrowserRouter,Switch,Route} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "ka-table/style.css";
import Login from '../pages/login';
import Inicio from '../pages/inicio';
import Mishorarios from '../pages/mis_horarios';
import ProtectedRoute from '../components/ProtectedRoute'
function Template() {
  return (
	<div>
		<BrowserRouter>			
			<Switch>        
				<Route exact path="/mihorario" component={Login}/> 
				<ProtectedRoute 
					exact 
					path="/mihorario/inicio"
					component={Inicio}
				/>
				<ProtectedRoute
					exact 
					path="/mihorario/mis_horarios"
					component={Mishorarios}
				/>
				<Route exact path="/mihorario/logout" component={Login}/>
			</Switch>
		</BrowserRouter>
	</div>
  );
}


export default Template;